<template>
  <div class="flex flex-col h-full">
    <div class="flex-auto overflow-scroll">
      <div class="flex justify-between items-center pt-4 px-4">
        <h3 class="text-2xl font-bold">Entradas</h3>
        <button
          @click="downloadCSV"
          class="rounded bg-primary hover:bg-primary-dark text-white font-bold p-1 px-4"
        >
          Descargar CSV
        </button>
      </div>

      <div
        v-if="
          !route.params.proveedor_id && proveedores && proveedores.length > 1
        "
        class="px-4 pt-4"
      >
        <select
          v-model="selectedProveedor"
          @change="filterEntradas"
          class="border border-gray-300 focus:border-gray-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
        >
          <option value="">Todos los proveedores</option>
          <option
            v-for="proveedor in proveedores"
            :key="proveedor.id"
            :value="proveedor.id"
          >
            {{ proveedor.nombre }}
          </option>
        </select>
      </div>

      <div
        v-if="entradas && entradas.length > 0"
        class="sm:hidden w-full text-left px-4 pb-4"
      >
        <div
          class="border boder-gray-300 rounded p-2 mt-4 cursor-pointer"
          v-for="entrada in entradas"
          v-bind:key="entrada.id"
        >
          <router-link :to="'/admin/entrada/' + entrada.id">
            <div class="flex flex-col">
              #{{ entrada.id }}

              <div class="mt-2">
                <label
                  class="block text-gray-700 text-sm font-bold"
                  for="nombre"
                >
                  Proveedor
                </label>
                <div class="flex items-center">
                  {{ entrada.proveedor.nombre }}
                </div>
              </div>

              <div class="mt-2 grid grid-cols-2">
                <div>
                  <label
                    class="block text-gray-700 text-sm font-bold"
                    for="nombre"
                  >
                    Fecha
                  </label>
                  <div class="flex items-center">
                    {{ entrada.created_at.split("T")[0] }}
                  </div>
                </div>
              </div>
            </div>
          </router-link>
        </div>
      </div>

      <div
        v-if="entradas && entradas.length > 0"
        class="hidden sm:block w-full text-left px-4 mt-4 pb-4"
      >
        <div
          class="border boder-gray-300 border-b-0 rounded overflow-hidden mt-4 bg-white"
        >
          <div class="overflow-scroll">
            <table class="w-full text-sm text-left">
              <thead class="text-s border-b border-b-gray-200">
                <th scope="col" class="py-3 px-6">Entrada</th>
                <th scope="col" class="py-3 px-6">Fecha</th>
                <th v-if="showAddButton" scope="col" class="py-3 px-6">
                  Proveedor
                </th>
              </thead>
              <tbody
                v-for="entrada in entradas"
                v-bind:key="entrada.id"
                class="text-s border-b"
              >
                <th
                  scope="row"
                  class="py-3 px-6 font-medium whitespace-nowrap underline cursor-pointer"
                >
                  <router-link
                    :to="
                      route.params.proveedor_id
                        ? `/proveedor/${route.params.proveedor_id}/entrada/${entrada.id}`
                        : '/admin/entrada/' + entrada.id
                    "
                  >
                    {{ entrada.id }}
                  </router-link>
                </th>
                <td class="py-3 px-6 whitespace-nowrap">
                  {{ entrada.created_at.split("T")[0] }}
                </td>
                <td
                  v-if="showAddButton"
                  class="py-3 px-6 whitespace-nowrap cursor-pointer"
                >
                  {{ entrada.proveedor.nombre }}
                </td>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showAddButton" class="p-4 flex-none border-t border-t-gray-300">
      <router-link :to="'/admin/entrada'">
        <button
          class="w-full bg-primary hover:bg-primary-dark rounded text-white font-bold py-2 px-4"
        >
          Agregar entrada
        </button>
      </router-link>
    </div>
  </div>
</template>

<script>
import { supabase } from "../supabase.js";
import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { useToast } from "vue-toast-notification";
import { useLoading } from "vue-loading-overlay";

const loading = useLoading({
  color: "#428b74",
  loader: "spinner",
});

export default {
  name: "Order",
  setup() {
    const route = useRoute();
    const entradas = ref(null);
    const showAddButton = ref(false);
    const proveedores = ref(null);
    const selectedProveedor = ref("");

    async function getEntradas() {
      let { data, error, status } = await supabase
        .from("entrada")
        .select("*, proveedor(id, nombre)")
        .order("created_at", { ascending: false });

      if (error && status !== 406) {
        throw error;
      }

      if (data) {
        if (route.params.proveedor_id) {
          entradas.value = data.filter((d) => {
            return d.proveedor.id == route.params.proveedor_id;
          });
          return;
        }

        entradas.value = data;
        return;
      } else if (error) {
        alert(error);
      }

      return;
    }

    async function getEntradasWithItems() {
      let { data, error, status } = await supabase
        .from("entrada")
        .select(
          "*, proveedor(id, nombre), entrada_item(cantidad_entregada, producto(nombre))"
        )
        .order("created_at", { ascending: false });

      if (error && status !== 406) {
        throw error;
      }

      if (data) {
        if (route.params.proveedor_id) {
          return data.filter((d) => {
            return d.proveedor.id == route.params.proveedor_id;
          });
        }

        return data;
      } else if (error) {
        throw error;
      }

      return [];
    }

    function convertToCSV(data) {
      const csvRows = [];

      // Headers
      csvRows.push("Entrada ID,Fecha,Proveedor,Producto,Cantidad Entregada");

      // Data rows
      data.forEach((entrada) => {
        const entradaId = entrada.id;
        const fecha = entrada.created_at.split("T")[0];
        const proveedor = entrada.proveedor.nombre;

        if (entrada.entrada_item && entrada.entrada_item.length > 0) {
          entrada.entrada_item.forEach((item) => {
            const producto = item.producto.nombre;
            const cantidad = item.cantidad_entregada;
            csvRows.push(
              `${entradaId},"${fecha}","${proveedor}","${producto}",${cantidad}`
            );
          });
        } else {
          // If no items, still include the entrada with empty product data
          csvRows.push(`${entradaId},"${fecha}","${proveedor}","",""`);
        }
      });

      return csvRows.join("\n");
    }

    function downloadFile(content, filename) {
      const blob = new Blob([content], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", filename);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    async function downloadCSV() {
      const loader = loading.show();

      try {
        let data;
        if (selectedProveedor.value) {
          // Use the currently filtered entradas with items
          const allData = await getEntradasWithItems();
          data = allData.filter(
            (d) => d.proveedor.id == selectedProveedor.value
          );
        } else if (route.params.proveedor_id) {
          // If we're in a specific provider route
          data = await getEntradasWithItems();
        } else {
          // Download all entradas
          data = await getEntradasWithItems();
        }

        const csv = convertToCSV(data);
        const proveedorName = selectedProveedor.value
          ? proveedores.value.find((p) => p.id == selectedProveedor.value)
              ?.nombre || "filtered"
          : "all";
        const filename = `entradas_${proveedorName}_${
          new Date().toISOString().split("T")[0]
        }.csv`;
        downloadFile(csv, filename);
        useToast().success("CSV descargado exitosamente", {
          position: "top-right",
        });
      } catch (error) {
        console.error("Error downloading CSV:", error);
        useToast().error("Error al descargar CSV", { position: "top-right" });
      } finally {
        loader.hide();
      }
    }

    async function filterEntradas() {
      if (selectedProveedor.value) {
        const filteredEntradas = await getEntradasWithItems();
        entradas.value = filteredEntradas.filter((d) => {
          return d.proveedor.id == selectedProveedor.value;
        });
      } else {
        getEntradas();
      }
    }

    onMounted(async () => {
      getEntradas();

      if (!route.params.proveedor_id) {
        showAddButton.value = true;
      }

      let { data, error, status } = await supabase
        .from("proveedores")
        .select("id, nombre");

      if (error && status !== 406) {
        throw error;
      }

      if (data) {
        proveedores.value = data;
      } else if (error) {
        alert(error);
      }
    });

    return {
      entradas,
      showAddButton,
      route,
      downloadCSV,
      proveedores,
      selectedProveedor,
      filterEntradas,
    };
  },
};
</script>
